export default __webpack_public_path__ + "static/media/activate_icon.eab02ac6.png";